module.exports = __webpack_public_path__ + "OpenSans-Light-39d27e13dce3dfe4cdc70a281ccdf113.woff2";